export const configParams = {
  lowerLimit: 5,
  upperLimit: 150,
  range: 30,
};

export const directionArr = ["L", "R", "U", "D"];

export const numberOfConsecutiveMovesAllowed = 2;

export const animationDirList = {
  L: "leftMove",
  R: "rightMove",
  U: "upwardMove",
  D: "downwardMove",
};

export const measureLimits = {
  lowerLimit: 1,
  upperLimit: 3,
};
